"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowScrollToEffect = exports.scrollWindowTo = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = require("react");

var scrollWindowTo = function scrollWindowTo() {
  var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'top';
  window.scrollTo({
    top: dir.startsWith('bottom') ? document.body.offsetHeight : 0,
    left: dir.endsWith('right') ? document.body.offsetWidth : 0,
    behavior: 'smooth'
  });
};

exports.scrollWindowTo = scrollWindowTo;

var useWindowScrollToEffect = function useWindowScrollToEffect() {
  var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'top';
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  (0, _react.useEffect)(function () {
    scrollWindowTo(dir); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dir].concat((0, _toConsumableArray2["default"])(dependencies)));
};

exports.useWindowScrollToEffect = useWindowScrollToEffect;